import { init } from './init';

const upsell = {
  init,
};

export { upsell };
